import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Recetario de budines salados',
    image: 'https://cdn.magicpatterns.com/uploads/fWrSuNCw9LpS5kCptS5t7g/bono_1.png',
    description: 'Consejos y trucos probados para que tus budines queden siempre esponjosos, húmedos y con la textura perfecta.'
  }, {
    title: 'Tabla de conversiones de ingredientes',
    image: 'https://cdn.magicpatterns.com/uploads/9n84b1w2G9XGH8gVrcXbGY/bono_4.png',
    description: 'Una guía rápida con conversiones, proporciones y equivalencias para que nunca te equivoques con las medidas.'
  }, {
    title: 'Ideas de glaseados y toppings para budines',
    image: 'https://cdn.magicpatterns.com/uploads/fNMRDkw1z7jg2D6B7MAj2p/bono_2.png',
    description: 'Aprende a preparar glaseados, coberturas y toppings que transforman cualquier budín simple en algo espectacular.'
  }];
  return <section className="py-20 px-4" data-id="element-28">
      <div className="max-w-5xl mx-auto" data-id="element-29">
        <div className="text-center mb-16" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#3D2B1F]" data-id="element-31">
            🎁 Bonos especiales
          </h2>
          <p className="text-xl md:text-2xl text-[#6B5344]" data-id="element-32">
            Al descargar el recetario hoy también recibirás:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-33">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-3xl overflow-hidden border border-[#E8D5C4] hover:border-[#D4850A]/50 transition-colors duration-300 flex flex-col shadow-md" data-id="element-34">
              <div className="relative group cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-35">
                <div className="absolute top-4 right-4 bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full z-10 flex items-center gap-1 shadow-lg animate-pulse" data-id="element-36">
                  <GiftIcon className="w-4 h-4" data-id="element-37" />
                  GRATIS
                </div>
                <img src={bonus.image} alt={bonus.title} loading="lazy" className="w-full h-56 object-contain bg-[#FEF3E2] p-4 transform transition-transform duration-500 group-hover:scale-105" data-id="element-38" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-39">
                <div className="text-[#D4850A] font-bold text-sm mb-2 uppercase tracking-wider" data-id="element-40">
                  📘 Bono {index + 1}
                </div>
                <h3 className="text-xl font-bold mb-3 text-[#3D2B1F]" data-id="element-41">
                  {bonus.title}
                </h3>
                <p className="text-[#9B8578] leading-relaxed flex-1 text-sm" data-id="element-42">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-center text-[#6B5344] mt-10 text-lg font-medium" data-id="element-43">
          Todo incluido sin costo adicional.
        </p>
      </div>
    </section>;
}